export const isPrerendering = typeof window === 'undefined';
export const notInIFrame = !isPrerendering && window.self === window.top;
